const IconDotsVertical = () => {
  return (
    <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <rect fill="none" height="256" width="256" />
      <circle cx="92" cy="60" r="12" fill="currentColor" />
      <circle cx="164" cy="60" r="12" fill="currentColor" />
      <circle cx="92" cy="128" r="12" fill="currentColor" />
      <circle cx="164" cy="128" r="12" fill="currentColor" />
      <circle cx="92" cy="196" r="12" fill="currentColor" />
      <circle cx="164" cy="196" r="12" fill="currentColor" />
    </svg>
  );
};

export default IconDotsVertical;
